export const PlayIcon = () => {
  return (
    <svg
      width='120'
      height='120'
      viewBox='0 0 120 120'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_2530_112419)'>
        <circle cx='60' cy='60' r='60' fill='white' />
        <path
          d='M70.9183 59.197C71.4569 59.5969 71.4569 60.4031 70.9183 60.803L54.9294 72.6717C54.2695 73.1615 53.3333 72.6905 53.3333 71.8687V48.1313C53.3333 47.3095 54.2695 46.8385 54.9294 47.3283L70.9183 59.197Z'
          fill='#FF0037'
        />
      </g>
      <defs>
        <clipPath id='clip0_2530_112419'>
          <rect width='120' height='120' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};
